"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const lodash_1 = require("lodash");
const util_1 = require("./util");
const idKey = (id) => (typeof id === 'string' ? id : util_1.toNum(id).toString());
const pageNum = (page) => (typeof page === 'number' ? page : page.page);
class PaginationStore {
    constructor(initialFilters) {
        this.pages = new Map();
        this.total = 0;
        this.pageOf = (id) => {
            return this.pages.get(idKey(id));
        };
        this.initialFilters =
            typeof initialFilters === 'function'
                ? initialFilters
                : () => initialFilters;
        this.filters = this.initialFilters();
    }
    get totalPages() {
        return this.total;
    }
    setPageOf(id, page) {
        this.pages.set(idKey(id), pageNum(page));
    }
    setTotalPages(totalPages) {
        this.total = typeof totalPages === 'number' ? totalPages : totalPages.total;
    }
    setFilters(filters) {
        // if filters have changed since last addAll, page numbers are invalidated
        if (!lodash_1.isEqual(filters, this.filters)) {
            this.reset();
        }
        this.filters = filters;
    }
    addAll(ids, page, totalPages, filters) {
        const pageNumber = pageNum(page);
        this.setFilters(filters);
        // clears old entries that were associated with this page
        for (const [id, n] of this.pages.entries()) {
            if (n === pageNumber) {
                this.pages.delete(id);
            }
        }
        for (const id of ids) {
            this.setPageOf(id, pageNumber);
        }
        this.setTotalPages(totalPages);
    }
    reset() {
        this.filters = this.initialFilters();
        this.pages.clear();
        this.total = 0;
    }
}
__decorate([
    mobx_1.observable,
    __metadata("design:type", Object)
], PaginationStore.prototype, "pages", void 0);
__decorate([
    mobx_1.observable,
    __metadata("design:type", Object)
], PaginationStore.prototype, "total", void 0);
__decorate([
    mobx_1.observable,
    __metadata("design:type", Object)
], PaginationStore.prototype, "filters", void 0);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], PaginationStore.prototype, "setPageOf", null);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PaginationStore.prototype, "setTotalPages", null);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PaginationStore.prototype, "setFilters", null);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array, Object, Object, Object]),
    __metadata("design:returntype", void 0)
], PaginationStore.prototype, "addAll", null);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], PaginationStore.prototype, "reset", null);
exports.PaginationStore = PaginationStore;
//# sourceMappingURL=pagination-store.js.map